import React from 'react'
import { GrSuperscript } from 'react-icons/gr'

export const strong = { title: 'Strong', value: 'strong' }

export const em = { title: 'Emphasis', value: 'em' }

export const underline = { title: 'Underline', value: 'underline' }

export const strikeThrough = {
  title: 'Strike',
  value: 'strike-through',
}

export const superscript = {
  title: 'Superscript',
  value: 'sup',
  blockEditor: {
    icon: GrSuperscript,
    render: (props: any) => (
      <React.Fragment>
        <sup>{props.children}</sup>
      </React.Fragment>
    ),
  },
}
